import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCheckboxFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.29.57H13.7c.95 0 1.72.77 1.72 1.72V13.7c0 .95-.77 1.72-1.72 1.72H2.3c-.95 0-1.72-.77-1.72-1.72V2.3c0-.95.77-1.72 1.72-1.72M12 5.97c.3-.38.24-.91-.13-1.21s-.91-.24-1.2.13L6.6 9.96 5 8.74c-.38-.28-.92-.2-1.2.17-.28.38-.2.92.17 1.2l2.29 1.72c.37.28.9.21 1.18-.15z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconCheckboxFilled;
